
import { Product } from "@/types/product";

export const ipxTC3AWP3PRO: Product = {
  id: "ipx-tc3a-wp3-pro",
  groupId: "avoip",
  name: "IPX-TC3A-WP3-PRO",
  subtitle: "10Gb Wall Plate Transceiver",
  description: "The IPX-TC3A-WP3-PRO is a premium triple-input wall plate transceiver that represents the pinnacle of 10G AV over IP technology in an elegant wall-mounted form factor. This professional-grade solution features two HDMI 2.0 inputs and one USB-C input, providing comprehensive connectivity options for modern presentation environments.\n\nDesigned for maximum flexibility, this 3-gang wall plate can function as both a transmitter and receiver, supporting 4K60 4:4:4 video with zero compression and zero latency. The inclusion of USB-C connectivity makes it especially suitable for modern BYOD environments, while maintaining compatibility with traditional HDMI sources.\n\nThe IPX-TC3A-WP3-PRO is perfect for high-end corporate boardrooms, executive meeting spaces, and premium educational facilities where both performance and versatility are essential.",
  features: [
    "Configure as Transmitter (Encoder) or Receiver (Decoder)",
    "4K60 4:4:4 Over 10G Fiber or Copper",
    "Zero Compression/Frame Latency (22us) for 4K60 4:2:0 and below",
    "1.3:1 Lossless Compression and Zero Frame Latency (100us) for 4K60 4:4:4",
    "Available for 10Gbps fiber MMF/SMF or 10Gbps copper networks",
    "Secure Content Encryption",
    "128x128 Capable with HDCP, Larger for Non-Encrypted Sources",
    "Video Wall Capability 8x8 (Pro Version)",
    "Windowing/Multi-viewer up to 32 windows (Pro Version)",
    "3ms Scaling (Pro Version)",
    "Seamless Switching (Pro Version)",
    "Break-away Switching",
    "Audio DSP",
    "Wall Plate Versions also available in white or black"
  ],
  specifications: [
    "Compression: Zero (4K30 4:4:4/4K60 4:2:0), 1.3:1(4K60 4:4:4)",
    "Latency: Zero Frame Latency (100us without Scaling, 3ms with Scaling)",
    "Bandwidth: 600MHz",
    "HDCP: HDCP 2.2",
    "Connectors",
    "HDMI: 2 Inputs, 1 Output",
    "Analog Audio: Stereo Line In/Out (3.5mm TRS Tip is Left, Ring is Right, Sleeve is Ground)",
    "10G Ethernet (C Version): 10G Copper RJ-45 330ft CAT 6A PoE+",
    "10G Ethernet (F Version): 10G Fiber SFP+ (DF Version)",
    "1G Ethernet: (1) 10/100/1000M PoE+ (PSE)",
    "RS-232: Up to 115k Baud (3.5mm TRS Tip TX, Ring RX, Sleeve Ground)",
    "IR: Bi-Directional (3.5mm TRS Tip TX, Ring 5V, Sleeve Ground)",
    "USB: 2 x USB 2.0 Type A, 1 x USB 2.0 Micro",
    "Expansion: ExtremeUSB, Dante and ReAX Options",
    "Control",
    "Webserver: Built-In Control Server",
    "Management Software: IPBaseT Manager (free download)",
    "3rd Party Control: Comprehensive Telnet API including Exclusive Aurora Wrapper Functions",
    "Physical & Power",
    "Mount: 3-Gang wall box (Optional accessory LVR-3G 3-gang Low Voltage Mounting Bracket)",
    "Power Supply: 48V DC (2 pin Euro) or PoE+ 25.4W (LAN)",
    "Power Consumption: 12.9 Watts",
    "Operating Temperature: 0 ~ 40 Celsius [32 ~ 100 Farenheit]",
    "Storage Temperature: -20 ~ 60 Celsius [-4 ~ 140 Farenheit]",
    "Relative Humidity: 20~90% RH [no condensation]"
  ],
  images: [
    "/lovable-uploads/d0f99dd4-88f9-492e-a5dd-e0e96123b441.png"
  ],
  videoUrl: "https://youtu.be/T_GmvE3ExoE?si=4mNv77MwcggNB8sA",
  slug: "ipx-tc3a-wp3-pro",
  networkSpeed: "10gb"
};
